import React from 'react';
import './Button.css';

const STYLES = ['btn--primary', 'btn--outline', 'btn--submit', 'btn--square'];
const SIZES = ['btn--small', 'btn--medium', 'btn--large', 'btn--mobile', 'btn--wide'];
const COLOR = ['primary', 'blue', 'red', 'green', 'orange'];

export const Button = ({
    children,
    type,
    onClick,
    disabled,
    buttonStyle,
    buttonSize,
    buttonColor,
    className
}) => {
    const checkButtonStyle = STYLES.includes(buttonStyle) ? buttonStyle : STYLES[0];
    const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : '';
    const checkButtonColor = COLOR.includes(buttonColor) ? buttonColor : '';
    const checkClassName = className !== undefined ? className : '';

    return (
        <button className={`btn ${checkButtonStyle} ${checkButtonSize} ${checkButtonColor} ${checkClassName}`} onClick={onClick} type={type} disabled={disabled}>
            {children}
        </button>
    );
};
